import { render, staticRenderFns } from "./MfaSettings.vue?vue&type=template&id=7c19cfa2&scoped=true&"
import script from "./MfaSettings.vue?vue&type=script&lang=ts&"
export * from "./MfaSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19cfa2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDialog,VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c19cfa2')) {
      api.createRecord('7c19cfa2', component.options)
    } else {
      api.reload('7c19cfa2', component.options)
    }
    module.hot.accept("./MfaSettings.vue?vue&type=template&id=7c19cfa2&scoped=true&", function () {
      api.rerender('7c19cfa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/auth/MfaSettings.vue"
export default component.exports